import clsx from 'clsx'

const DashboardCard = ({ children, className, ...props }) => {
  return (
    <div
      className={clsx(
        'bg-surface border border-border shadow-card rounded-card min-w-0 p-3 sm:p-4 hd:p-6',
        className
      )}
      {...props}
    >
      {children}
    </div>
  )
}

export default DashboardCard
